var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-prod"},[_c('div',{staticClass:"process",attrs:{"id":"process"}},_vm._l((_vm.typeList),function(item,index){return _c('div',{key:index,staticClass:"step",class:{ isActived: _vm.actived === index },on:{"click":function($event){return _vm.handleChange(item)}}},[_c('span',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }